import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import MenuButton from '../Button/MenuButton';
import { ReactComponent as ProfileIcon } from '../../assets/Profile Black icon.svg';
import { ReactComponent as ProfileIconSelected } from '../../assets/Profile 1.svg';
import { ReactComponent as PasswordIcon } from '../../assets/PasswordIcon.svg';
import { ReactComponent as PasswordIconSelected } from '../../assets/Lock 1.svg';
import { ReactComponent as SubscrptionIcon } from '../../assets/card black.svg';
import { ReactComponent as SubscrptionIconSelected } from '../../assets/Card 1.svg';
import { ReactComponent as HeadphoneIcon } from '../../assets/Headphone Black.svg';
import { ReactComponent as HeadphoneIconSelected } from '../../assets/Headphone 1.svg';
import { ReactComponent as ChangeCardIconSelected } from '../../assets/Document.svg';
import { ReactComponent as ChangeCardIcon } from '../../assets/Updated_Document.svg';

import LogoutIcon from '../../assets/Logout.svg';
import SideBarBgContainer from '../SideBarBgContainer/SideBarBgContainer';
import {
  ProfileContext,
  ProfileContextProps,
} from '../../context/ProfileContext';
import { storeTab } from '../../utils/auth-token-utils/cookie';
import './ConsumerSidebar.css';
import { Typography, Box } from '@mui/material';
import LeftArrow from '../../assets/Left 1.svg';
import { AuthContext } from '../../context/AuthContext';

const ConsumerSidebar: React.FC = () => {
  const navigate = useNavigate();

  const { activeTab, handleActiveTab, handleShowLogoutPopup } = useContext(
    ProfileContext,
  ) as ProfileContextProps;

  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error('Auth Context must be used within a AuthProvider');
  }

  const handleLogout = async () => {
    handleShowLogoutPopup(true);
  };

  const handleBackClick = () => {
    navigate('/participant/dashboard');
  };

  const handlePasswordSelection = () => {
    handleActiveTab('password');
    storeTab('password');
    navigate('/participant/resetPassword');
  };

  const handleProfile = () => {
    handleActiveTab('profile');
    storeTab('profile');
    navigate('/participant/editprofile');
  };

  const handleSubscription = () => {
    handleActiveTab('subscription');
    storeTab('subscription');
    navigate('/participant/subscription');
  };

  const handleChangeCard = () => {
    handleActiveTab('addcard');
    storeTab('addcard');
    navigate('/participant/changeCard');
  };

  const handleSupport = () => {
    handleActiveTab('support');
    storeTab('support');
    navigate('/participant/support');
  };

  return (
    <SideBarBgContainer className="sidebar">
      <Box sx={{ marginX: 'auto' }} className="menu-buttons">
        <img src={LeftArrow} onClick={handleBackClick} className="arrow" />
        <Box sx={{ '& > *:not(:last-child)': { mb: 2 } }}>
          <MenuButton
            icon={
              activeTab === 'profile' ? (
                <ProfileIconSelected />
              ) : (
                <ProfileIcon />
              )
            }
            selected={activeTab === 'profile'}
            onClick={handleProfile}
          >
            Edit Profile
          </MenuButton>
          <MenuButton
            icon={
              activeTab === 'password' ? (
                <PasswordIconSelected />
              ) : (
                <PasswordIcon />
              )
            }
            onClick={handlePasswordSelection}
            selected={activeTab === 'password'}
          >
            Change Password
          </MenuButton>
          <MenuButton
            icon={
              activeTab === 'subscription' ? (
                <SubscrptionIconSelected />
              ) : (
                <SubscrptionIcon />
              )
            }
            onClick={handleSubscription}
            selected={activeTab === 'subscription'}
          >
            Subscription Details
          </MenuButton>
          <MenuButton
            icon={
              activeTab === 'addcard' ? (
                <ChangeCardIconSelected />
              ) : (
                <ChangeCardIcon />
              )
            }
            onClick={handleChangeCard}
            selected={activeTab === 'addcard'}
          >
            Update Credit Card
          </MenuButton>
          <MenuButton
            icon={
              activeTab === 'support' ? (
                <HeadphoneIconSelected />
              ) : (
                <HeadphoneIcon />
              )
            }
            onClick={handleSupport}
            selected={activeTab === 'support'}
          >
            Help & Support
          </MenuButton>
        </Box>
      </Box>
      <div className="logout-container" onClick={handleLogout}>
        <div className="logout-icon">
          <img src={LogoutIcon} className="logout-image" alt="Logout" />
        </div>
        <Typography>Logout</Typography>
      </div>
    </SideBarBgContainer>
  );
};

export default ConsumerSidebar;
